import { get } from "lodash";
import { CURRENCY_SYMBOL } from "utils/constants";

const PricingItem = ({ title, price, per, currency, breakdown = [] }) => {
  const breakdownTotal = breakdown.reduce(
    (acc, item) => acc + Number(get(item, "cost", 0)),
    0,
  );
  const totalPrice = (Number(price) + breakdownTotal).toFixed(2);

  return (
    <div className="pricinglmf__item">
      <div className="--header">
        <div className="--name">
          <h3>{title}</h3>
        </div>
        <div className="--price">
          <span className="main">
            {totalPrice} {CURRENCY_SYMBOL[currency]}
          </span>
          <small>{per}</small>
        </div>
      </div>

      <div className="--breakdown">
        <div className="row">
          <span>Formule {title}</span>
          <span>
            {Number(price).toFixed(2)} {CURRENCY_SYMBOL[currency]}
          </span>
        </div>
        {breakdown.map((item, index) => (
          <div className="row" key={index}>
            <span>{get(item, "insurancePlan.name")}</span>
            <span>
              {Number(get(item, "cost")).toFixed(2)}{" "}
              {CURRENCY_SYMBOL[get(item, "currency")]}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PricingItem;
